import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  return (
    <footer id="main-footer" className="reference-footer">
      {/* Navy support section */}
      <section className="footer-support-section">
        <nav className="footer-policy-links" aria-label="Footer navigation">
          <Link to="/terms-and-conditions">Terms and Conditions</Link>

          <Link to="/responsible-gaming">Responsible Gaming</Link>
        </nav>

        <strong className="footer-support-title">24X7 Support</strong>
      </section>

      {/* Security section */}
      <section className="footer-security-section">
        <div className="footer-security-message">
          <img
            src={`${process.env.PUBLIC_URL}/Images/footer/ssl.png`}
            alt="Secure SSL encryption"
            className="footer-secure-image"
            loading="lazy"
          />

          <div className="footer-security-copy">
            <strong>100% SAFE</strong>
            <span>Protected connection and encrypted data.</span>
          </div>
        </div>

        <div
          className="footer-responsibility-logos"
          aria-label="Responsible gaming"
        >
          <img
            src={`${process.env.PUBLIC_URL}/Images/footer/18plus.png`}
            alt="GamCare"
            loading="lazy"
          />

          <img
            src={`${process.env.PUBLIC_URL}/Images/footer/gamecare.png`}
            alt="GamCare"
            loading="lazy"
          />

          <img
            src={`${process.env.PUBLIC_URL}/Images/footer/gt.png`}
            alt="Gambling Therapy"
            loading="lazy"
          />
        </div>
      </section>

      {/* Copyright */}
      <section className="footer-copyright">
        Rules &amp; Regulations © 2023
      </section>
    </footer>
  );
};

export default Footer;
